import React, { useState, useEffect, Fragment, forwardRef, useRef } from "react";
import { Row, Col, Label, Input, Form, FormGroup, Button, Card } from "reactstrap";

import { useForm } from "react-hook-form";
import Dropzone from "react-dropzone-uploader";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { mykyc } from "../../../../../redux/kyc/action";
import RequiredIndicator from "../../../../partial/RequiredIndicator";
import { submitKyc, validatePanCard } from "../../../../../api";
import {
  getFromLocalStorage,
  setInLocalStorage,
} from "../../../../../hooks/useLocalStorage";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import validateFile from "../../../../../utilities/validateFile";
import handleupload from "../../../../../utilities/handleUpload";
import PDFViewer from "../../../../../utilities/PDFViewer";
import { kycInitialState } from "../../../../../redux/kyc/reducer";
import { Edit, InfoOutlined } from "@mui/icons-material";
import FileUploadComponent from "../../../../common/FileUpload";
import KycViewNote from "../../kyc_note/KycViewNote";
import KycEditNote from "../../kyc_note/KycEditNote";
import specialCharacterConstrains from "../../../../../utilities/specialCharacterConstrains";

const Aadhar = (props, ref) => {
  const {
    activeStep,
    setActiveStep,
    setStep3Valid,
    dealerKycData,
    is_kyc_submitted,
    is_kyc_active,
    isUpdated,
    isGstVerified,
    isMSMEVerified,
    re_kyc,
    isGSTDocUpdated
  } = props;
  const showReadOnlyAadhar = (is_kyc_submitted || is_kyc_active);
  const dispatch = useDispatch();
  const kycData = useSelector((state) => state.Kyc);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const {
    handleSubmit,
    register,
    setValue,
    trigger,
    errors,
    setError,
    watch,
    getValues,
  } = useForm();
  const [aadharfileUrl, setAadharFileUrl] = useState("");
  const [panfileUrl, setPanFileUrl] = useState("");
  const [supportingDocfileUrl, setSupportingDocFileUrl] = useState("");
  const [aadharfileUploadFlag, setAadharFileUploadFlag] = useState(false);
  const [panfileUploadFlag, setPanFileUploadFlag] = useState(false);
  const [supportingDocfileUploadFlag, setSupportingDocFileUploadFlag] =
    useState(false);
  const kycDataRef = useRef(useSelector((state) => state.Kyc));
  const [defaultEntityType, setDefaultEntityType] = useState("");
  const insureCheckbox = watch("insureCheckbox", false);
  useEffect(() => {
    async function checkDetails() {
      const storedData = kycData.authorizedSignatory;
      Object.keys(storedData).forEach((fieldName) => {
        setValue(fieldName, storedData[fieldName]);
      });
      setAadharFileUrl(getValues()["signatory_aadhar_image"]);
      setPanFileUrl(getValues()["signatory_pan_image"]);
      setSupportingDocFileUrl(getValues()["supporting_doc"]);
    }
    checkDetails();
    // For debugging
    console.log("KYC Data in Aadhar Component:", kycData);
    console.log("MSME in KYC:", kycData?.msme);
    console.log("is_msme_verified:", kycData?.msme?.is_msme_verified);
  }, []);

  const handleBack = () => {
    if (is_kyc_submitted) {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    } else {
      const rhfdata = getValues();
      dispatch(
        mykyc({
          ...kycData,
          authorizedSignatory: { ...kycData.authorizedSignatory, ...rhfdata },
          txnid: Date.now(),
        })
      );
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  const submitForm = async (data) => {

    if (isGstVerified && !isGSTDocUpdated && re_kyc) {
      Swal.fire({
        icon: "warning",
        title: "Document Update Required",
        text: "Please update GST document before submitting Re-KYC."
      });
      return;
    }

    setLoading(true);

    // --- Ensure signatory_relationship and is_proprietor are carried forward ---
    let signatory_relationship = kycData?.authorizedSignatory?.signatory_relationship
      || kycData?.panCard?.signatory_relationship
      || "";
    let is_proprietor = kycData?.authorizedSignatory?.is_proprietor
      || (signatory_relationship === "Proprietor")
      || false;

    // Merge signatory_relationship and is_proprietor into data
    const mergedData = {
      ...data,
      signatory_relationship,
      is_proprietor
    };

    // Update Redux with mergedData
    dispatch(
      mykyc({
        ...kycData,
        authorizedSignatory: { ...kycData.authorizedSignatory, ...mergedData },
        txnid: Date.now(),
      })
    );

    // Prepare payload for API
    const panData = {
      user_pan_card_number: kycData?.panCard?.user_pan_card_number?.toUpperCase(),
      user_pan_card_name: kycData?.panCard?.user_pan_card_name,
      user_pan_card_image: kycData?.panCard?.user_pan_card_image,
      signatory_relationship,
    };
    const gstData = {
      gstin_state: kycData?.gstin?.gstin_state,
      gstin_pincode: kycData?.gstin?.gstin_pincode,
      // entity_type: kycData?.gstin?.entity_type,
      gstin_number: kycData?.gstin?.gstin_number?.toUpperCase(),
      gstin_account_name: kycData?.gstin?.gstin_account_name,
      gstin_image: kycData?.gstin?.gstin_image
    };
    const tanData = {
      tan_card_number: kycData?.tan?.tan_card_number,
      tan_card_image: kycData?.tan?.tan_card_image
    };
    const bankdetailsData = {
      bank_account_number: kycData?.bankDetails?.bank_account_number,
      bank_account_name: kycData?.bankDetails?.bank_account_name,
      bank_name: kycData?.bankDetails?.bank_name,
      ifsc_code: kycData?.bankDetails?.ifsc_code,
      cancelled_cheque_number: kycData?.bankDetails?.cancelled_cheque_number,
      cancelled_cheque_image: kycData?.bankDetails?.cancelled_cheque_image,
      is_bank_details_verified: kycData?.bankDetails?.is_bank_details_verified
    };

    const msmeData = {
      msme_certificate_number: kycData?.msme?.msme_certificate_number,
      msme_certificate_image: kycData?.msme?.msme_certificate_image,
      is_msme_verified: kycData?.msme?.is_msme_verified,
    };

    const finalPayloadFromRedux = {
      ...panData,
      ...gstData,
      ...tanData,
      ...bankdetailsData,
      ...msmeData,
      ...mergedData,
    };

    if (isGstVerified) {
      finalPayloadFromRedux.new_kyc_name = kycData?.gstin?.tradeName;
    } else {
      finalPayloadFromRedux.new_kyc_name = kycData?.panCard?.user_pan_card_name;
    }
    finalPayloadFromRedux.is_pan_verified = false;
    finalPayloadFromRedux.panNSDLVerify = false;
    finalPayloadFromRedux.is_gstn_verified = false;
    finalPayloadFromRedux.partnership_id = getFromLocalStorage("user")?.partnerInfo?.partnership_id;
    finalPayloadFromRedux.consolidator_id = getFromLocalStorage("user")?.consolidatorInfo?.consolidator_id;
    finalPayloadFromRedux.re_kyc = getFromLocalStorage("user")?.partnerInfo?.re_kyc;
    console.log("Final Payload:", finalPayloadFromRedux);
    await submitKyc(finalPayloadFromRedux)
      .then((res) => {
        setLoading(false);
        if (res.status === 200) {
          setInLocalStorage("user", {
            ...getFromLocalStorage("user"),
            partnerInfo: {
              ...getFromLocalStorage("user").partnerInfo,
              is_kyc_submitted: true,
            },
          });
          Swal.fire({
            icon: "success",
            title: "KYC documents submitted successfully!",
            text: `Please note the Ticket number for the request ${res.data.result.ticketNo}`,
          }).then(() => {
            setLoading(false);
            dispatch(mykyc(kycInitialState));
            navigate("/requests/my-requests");
          });
        }
      })
      .catch((err) => {
        console.log(err, "err");
        toast.error("Invalid Details");
        setLoading(false)
      });
  };

  return (
    <Fragment>
      <Row>
        <Col xl="12" md="12" sm="12" className="mt-4" key={1}>
          <div className="project-box">
            {is_kyc_active && !re_kyc ? (
              <span className={`badge badge-success`}>{"Verified"}</span>
            ) : (
              ""
            )}

            <div className="mt-3">
              {showReadOnlyAadhar ? (
                <>
                <Form
                  className="form-bookmark needs-validation"
                  onSubmit={handleSubmit(submitForm)}
                >
                  <Row>
                    <Col xl="6" md="6">
                      <FormGroup>
                        <Label>{"Aadhar Card Number"}</Label>
                        <Input
                          className="form-control"
                          name="signatory_aadhar_number"
                          type="text"
                          defaultValue={kycData?.authorizedSignatory?.signatory_aadhar_number}
                          readOnly
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label>{"Name on Aadhar Card"}</Label>
                        <Input
                          className="form-control"
                          name="signatory_aadhar_name"
                          type="text"
                          defaultValue={kycData?.authorizedSignatory?.signatory_aadhar_name}
                          readOnly
                        />
                      </FormGroup>
                    </Col>
                    <Col xl="6" md="6" className="d-flex justify-content-center">
                      <FormGroup className="text-center">
                        <Label>{"Aadhar Document"}</Label>
                        <FileUploadComponent name="signatory_aadhar_image" fileUploadFlag={false} data={kycData?.authorizedSignatory?.signatory_aadhar_image} viewOnly={true} />
                      </FormGroup>
                    </Col>
                    <Col xl="6" md="6">
                      <Row>
                        <Col xl="12" md="12">
                          <FormGroup>
                            <Label>{"PAN Card Number"}</Label>
                            <Input
                              className="form-control"
                              name="signatory_pan_number"
                              type="text"
                              defaultValue={kycData?.authorizedSignatory?.signatory_pan_number}
                              readOnly
                            />
                          </FormGroup>
                          <FormGroup>
                            <Label>{"Name on PAN Card"}</Label>
                            <Input
                              className="form-control"
                              name="signatory_pan_name"
                              type="text"
                              defaultValue={kycData?.authorizedSignatory?.signatory_pan_name}
                              readOnly
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </Col>
                    <Col xl="6" md="6" className="d-flex justify-content-center">
                      <FormGroup className="text-center">
                        <Label>{"PAN document"}</Label>
                        <FileUploadComponent name="signatory_pan_image" data={kycData?.authorizedSignatory?.signatory_pan_image} viewOnly={true} />
                      </FormGroup>
                    </Col>
                    {/* signatory_relationship section removed */}
                    {re_kyc ? <Col xl="6" md="6">
                      <FormGroup style={{ textAlign: "center" }}>
                        <div className="form-check">
                          <div className="checkbox pl-10">
                            <Input
                              id="invalidCheck"
                              name="insureCheckbox"
                              type="checkbox"
                              innerRef={register({ required: true })}
                            />
                            <Label htmlFor="invalidCheck">
                              {
                                "I ensure the Uploaded documents represent accurate information"
                              }
                            </Label>

                            <span style={{ color: "red" }}>
                              {errors.insureCheckbox &&
                                "You must agree before submitting"}
                            </span>
                          </div>
                        </div>
                      </FormGroup>
                      <KycEditNote />
                    </Col> :
                      <Col xl="6" md="6">
                        <FormGroup style={{ textAlign: "center" }}>
                          <div className="form-check">
                            <div className="checkbox pl-10">
                              <Input
                                id="invalidCheck"
                                name="insureCheckbox"
                                type="checkbox"
                                checked={is_kyc_submitted}
                                readOnly
                              />
                              <Label htmlFor="invalidCheck">
                                {
                                  "I ensure the Uploaded documents represent accurate information"
                                }
                              </Label>
                            </div>
                          </div>
                        </FormGroup>
                        <KycViewNote />
                      </Col>
                    }
                    <Col xl="6" md="6" className="d-flex justify-content-center">
                      <FormGroup className="text-center">
                        <Label>{"Supporting document"}</Label>
                        <FileUploadComponent name="supporting_doc" fileUploadFlag={false} data={kycData?.authorizedSignatory?.supporting_doc} viewOnly={true} />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row className="justify-content-between">
                    <Col md="auto">
                      {activeStep !== 0 && (
                        <Button
                          color="info"
                          disabled={activeStep === 0}
                          onClick={handleBack}
                        >
                          Back
                        </Button>
                      )}
                    </Col>
                    <Col md="auto">
                      {(re_kyc || !is_kyc_submitted) && (
                        <Button type="submit" color="success" disabled={!insureCheckbox}>
                          Submit
                        </Button>
                      )}
                    </Col>
                  </Row>
                </Form>
                </>
              ) : (getFromLocalStorage("ROLE")?.key == "DEALERSHIP_MANAGER" || getFromLocalStorage("ROLE")?.key == "CONSOLIDATOR") && (
                <Form
                  className="form-bookmark needs-validation"
                  onSubmit={handleSubmit(submitForm)}
                >
                  <Row>
                    <Col xl="6" md="6">
                      <FormGroup>
                        <Label>{"Aadhar Card Number"}</Label>{" "}
                        <Input
                          className="form-control"
                          name="signatory_aadhar_number"
                          type="text"
                          defaultValue={getValues()["signatory_aadhar_number"]}
                          innerRef={register(specialCharacterConstrains(false, "Aadhar Number is required", {
                            minLength: {
                              value: 12,
                              message: "Aadhar Number should be 12 digits",
                            }
                          }))}
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                            if (event.target.value.length >= 12) {
                              event.preventDefault();
                            }
                          }}
                        />
                        <span style={{ color: "red" }}>
                          {errors.signatory_aadhar_number && (
                            <span>
                              {errors.signatory_aadhar_number.message}
                            </span>
                          )}
                        </span>
                      </FormGroup>
                      <FormGroup>
                        <Label>{"Name on Aadhar Card"}</Label>{" "}
                        <Input
                          className="form-control"
                          name="signatory_aadhar_name"
                          type="text"
                          innerRef={register(specialCharacterConstrains(false, "Name on Aadhar is required"))}
                          defaultValue={getValues()["signatory_aadhar_name"]}
                        />
                        <span style={{ color: "red" }}>
                          {errors.signatory_aadhar_name?.message}
                        </span>
                      </FormGroup>
                    </Col>
                    <Col xl="6" md="6" className="d-flex justify-content-center">
                      <FormGroup style={{ textAlign: "center" }}>
                        <Label>{"Aadhar Document"}</Label>
                        <FileUploadComponent
                          register={register}
                          name="signatory_aadhar_image"
                          setValue={setValue}
                          trigger={trigger}
                          getValues={getValues}
                          data={aadharfileUrl}
                          add={getValues()["signatory_aadhar_image"]?.length > 0 ? false : true}
                          pdfImageOnly={true}
                          required={false}
                        />
                        <span style={{ color: "red" }}>
                          {errors.signatory_aadhar_image && (
                            <span>Signatory Aadhar Image is required</span>
                          )}
                        </span>
                      </FormGroup>
                    </Col>
                    <Col xl="6" md="6">
                      <Row>
                        <Col xl="12" md="12">
                          <FormGroup>
                            <Label>{"PAN Card Number"}</Label>{" "}
                            <Input
                              className="form-control"
                              name="signatory_pan_number"
                              type="text"
                              defaultValue={getValues()["signatory_pan_number"]}
                              innerRef={register({
                                required: {
                                  value: false,
                                  message: "PAN number is required"
                                },
                                pattern: {
                                  value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                                  message: "PAN number format is wrong",
                                },
                              })}
                              onChange={(e) => {
                                const upperCasePan = e.target.value.toUpperCase();
                                e.target.value = upperCasePan;
                              }}
                            />
                            <span style={{ color: "red" }}>
                              {errors.signatory_pan_number && (
                                <span>
                                  {errors.signatory_pan_number.message}
                                </span>
                              )}
                            </span>
                          </FormGroup>
                          <FormGroup>
                            <Label>{"Name on PAN Card"}</Label>{" "}
                            <Input
                              className="form-control"
                              name="signatory_pan_name"
                              type="text"
                              innerRef={register(specialCharacterConstrains(false, "Pan name is required"))}
                              defaultValue={getValues()["signatory_pan_name"]}
                            />
                            <span style={{ color: "red" }}>
                              {errors.signatory_pan_name?.message}
                            </span>
                          </FormGroup>
                        </Col>
                      </Row>
                    </Col>
                    <Col xl="6" md="6" className="d-flex justify-content-center">
                      <FormGroup style={{ textAlign: "center" }}>
                        <Label>{"PAN document"}</Label>
                        <FileUploadComponent
                          register={register}
                          name="signatory_pan_image"
                          setValue={setValue}
                          trigger={trigger}
                          getValues={getValues}
                          data={panfileUrl}
                          add={getValues()["signatory_pan_image"]?.length > 0 ? false : true}
                          pdfImageOnly={true}
                          required={false}
                        />
                        <span style={{ color: "red" }}>
                          {errors.signatory_pan_image && (
                            <span>Signatory Pan Image is Required</span>
                          )}
                        </span>
                      </FormGroup>
                    </Col>
                    {/* signatory_relationship section removed */}
                    <Col xl="6" md="6">
                      <FormGroup style={{ textAlign: "center" }}>
                        <div className="form-check">
                          <div className="checkbox pl-10">
                            <Input
                              id="invalidCheck"
                              name="insureCheckbox"
                              type="checkbox"
                              innerRef={register({ required: true })}
                            />
                            <Label htmlFor="invalidCheck">
                              {
                                "I ensure the Uploaded documents represent accurate information"
                              }
                            </Label>

                            <span style={{ color: "red" }}>
                              {errors.insureCheckbox &&
                                "You must agree before submitting"}
                            </span>
                          </div>
                        </div>
                      </FormGroup>
                      <KycEditNote />
                    </Col>
                    <Col xl="6" md="6" className="d-flex justify-content-center">
                      <FormGroup style={{ textAlign: "center" }}>
                        <Label>{"Supporting Document"}</Label>{" "}
                        <FileUploadComponent register={register} name="supporting_doc" required={false} fileUploadFlag={supportingDocfileUploadFlag} setValue={setValue} trigger={trigger} getValues={getValues} data={supportingDocfileUrl} add={getValues()["supporting_doc"]?.length > 0 ? false : true} pdfImageOnly={true} />
                        <span style={{ color: "red" }}>
                          {errors.supporting_doc && (
                            <span>Supporting Document is required</span>
                          )}
                        </span>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row className="justify-content-between">
                    <Col md="auto">
                      {activeStep !== 0 && (
                        <Button
                          color="info"
                          disabled={activeStep === 0}
                          onClick={handleBack}
                        >
                          &lt;&lt; Back
                        </Button>
                      )}
                    </Col>
                    <Col md="auto">
                      {(!is_kyc_active || re_kyc) && (
                        <Button type="submit" color="success" disabled={loading}>
                          {loading ? "Loading..." : "Submit"}
                        </Button>
                      )}
                    </Col>
                  </Row>
                </Form>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </Fragment>
  );
};

export default Aadhar;